import { render, staticRenderFns } from "./VerticalNavMenuGroup.vue?vue&type=template&id=4a1dccd9"
import script from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuGroup.vue?vue&type=style&index=0&id=4a1dccd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports